import ReuniLogo from '../assets/reuni-logo.svg';
import '../styles/components/Nav.scss';

const Nav = () => {
	return (
		<nav className="navbar">
			<div className="logo">
				<img src={ReuniLogo} alt="reuni logo" />
			</div>
		</nav>
	);
};

export default Nav;
